module.exports = __webpack_public_path__ + "static/media/client_2.05f85d53.png";